import {updateFontSize} from './utils/update-font-size'
import {isTouchDevice} from './utils/check-device'
import {getSmoothScroll, smoothScrollPause, smoothScrollPlay} from "./scroll-smoother";
import {getCookie, setCookie} from "./utils/cookies";

let defaultFontSize = 16
let smallScreenHeightFontSize = 16
let maxFontSize = 36

window.onbeforeunload = function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
}
isTouchDevice()

updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize)

let lastWidth = $(window).width();
$(window).on('resize', function () {
  const currentWidth = $(window).width();
  if (currentWidth !== lastWidth) {
    lastWidth = currentWidth;
    updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize)
    const currentScrollStatus = getSmoothScroll();
    if (currentScrollStatus.paused() === true && $('.history-heroes').length > 0) {
      smoothScrollPlay()
    }
    window.initStickyBlock();
    window.animateLogoInNavigation();
    window.initOurExperienceAnimations();
    window.initClientReviewsScripts();
    window.initSymbolVideoSignAnimation();
    window.initSymbolVideoTextAnimation();
    window.setupButtonAnimation();
    window.headerImageContentInit();
    window.initDynamicPinnedSlides();
    window.horizontalPinnedScroll();
    window.initHeroesStories();
    window.initOurTeamBlock();
    window.initHistoryHeroesSlider();
    window.initBasicCarousel();
    window.initLogoAnimations();
    window.initTabSwiper();
    window.initCarTypeSwiper();
    window.initLogoSwiper();
    window.textScroll();
    $('[data-rotate-in-animate] h1, [data-rotate-in-animate] .h1').addClass('opacity-100')
  }
})

function animateLoading() {
  let html = $('html')
  if (!$(html).hasClass('xyz')) {
    $(html).removeClass('overflow-hidden');
  }
  $('body').css({opacity: 1})
}

$(document).ready(function () {
  if ($('.intro-modal').length) {
    // animateLoading()
  } else {
    setTimeout(function () {
      animateLoading()
    }, 1200)
  }

})

$('body').on('click', 'button, a, .btn-hover-switch, .js--calculator-step-two-type, input:checkbox, input:radio, .js--lang-switcher, .js-accordion-title, .js--change-news-category li', function () {
  if ($(this).hasClass('js--modal-open-sound') || !$('.js--sound-button').hasClass('js--sound-enabled') || $(this).hasClass('js--swiper-sound')) {
    return
  }
  $("#hoverSound")[0].currentTime = 0;
  $("#hoverSound")[0].play();
});
$('body').on('click', '.js--modal-open-sound', function () {
  if (!$('.js--sound-button').hasClass('js--sound-enabled')) {
    return
  }
  $("#popupSound")[0].currentTime = 0;
  $("#popupSound")[0].play();
});


$('body').on('click', '.js--sound-button', function () {
  if ($(this).hasClass('js--sound-enabled')) {
    $('.js--sound-off').removeClass('d-none')
    $('.js--sound-on').addClass('d-none')
    $(this).removeClass('js--sound-enabled')
    setCookie('sounds', false, 1);
  } else {
    $('.js--sound-off').addClass('d-none')
    $('.js--sound-on').removeClass('d-none')
    $(this).addClass('js--sound-enabled')
    setCookie('sounds', true, 1);

  }
});

$(document).ready(function () {
  if (getCookie('sounds') && getCookie('sounds') === 'true') {
    $('.js--sound-off').addClass('d-none')
    $('.js--sound-on').removeClass('d-none')
    $('.js--sound-button').addClass('js--sound-enabled')
  }
});
